'use client'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import { getUserId } from '@/app/lib/actions'
import VendorProductsSection from '../components/settings/VendorProductsSection'
import PersonalInfoForm from '../components/settings/PersonalInfoForm'
import AvatarUpload from '../components/settings/AvatarUpload'
import SidebarMarginWrapper from '../components/SidebarMarginWrapper'
import toast from 'react-hot-toast'

const tabs = ['Perfil', 'Avatar', 'Produtos'] as const

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState<typeof tabs[number]>('Perfil')
  const [loading, setLoading] = useState(true)
  const router = useRouter()

  useEffect(() => {
    const checkAuth = async () => {
      const userId = await getUserId()
      if (!userId) {
        localStorage.setItem('unauth_redirect', '1')
        router.push('/')
      } else {
        setLoading(false)
      }
    }

    checkAuth()
  }, [router])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const redirectFlag = localStorage.getItem('unauth_redirect')
      if (redirectFlag) {
        toast.error('Você precisa estar logado para acessar as configurações')
        localStorage.removeItem('unauth_redirect')
      }
    }
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <p className="text-gray-600 text-lg animate-pulse">🔒 Verificando autenticação...</p>
      </div>
    )
  }

  return (
    <SidebarMarginWrapper>
      <div className="min-h-screen px-4 py-8 md:px-10 bg-gray-50 transition-all">
        <h1 className="text-3xl font-bold mb-8 text-gray-800">Configurações da Conta</h1>

        {/* Tabs */}
        <div className="flex gap-2 sm:gap-4 border-b border-gray-200 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 text-sm sm:text-base font-medium transition-all duration-200 border-b-2 ${
                activeTab === tab
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Tab content area */}
        <div className="bg-white p-6 rounded-xl shadow-md">
          {activeTab === 'Perfil' && <PersonalInfoForm />}
          {activeTab === 'Avatar' && <AvatarUpload />}
          {activeTab === 'Produtos' && <VendorProductsSection />}
        </div>
      </div>
    </SidebarMarginWrapper>
  )
}
